module.exports = __webpack_public_path__ + "img/empty.47306196.png";